import { type IMaxPlanRulesContentProps } from "../types/types";
import { BillInsuranceRulesFiles } from "./BillInsuranceRulesFiles";

export const BillInsuranceRulesContent: React.FC<IMaxPlanRulesContentProps> = ({
  title,
  hideTitle,
}) => {
  return (
    <div className="gap-6">
      {!hideTitle && title && <h4 className="my-5">{title}</h4>}
      <h5 className="my-4">
        Jeigu negalėsite dirbti dėl ligos, nelaimingo atsitikimo ar praradę
        darbą ne savo iniciatyva, šis draudimas jus apsaugos nuo rūpesčio, kaip
        apmokėti sąskaitas, už kurias paprastai atsiskaitote „Viena sąskaita“
        paskyroje.
      </h5>
      <ul className="my-4">
        <li>
          Netekus nuolatinių pajamų, draudimas galės kas mėnesį, jeigu reikės
          net iki pusės metų, už jus apmokėti sąskaitas, pateikiamas „Viena
          sąskaita“ platformoje.
        </li>
        <li>
          Mėnesinės draudimo išmokos suma bus apskaičiuojama atsižvelgiant į
          tai, koks bus šioje paskyroje, prie pasirinkto būsto, apmokėtų 3
          mėnesių sąskaitų vidurkis.
        </li>
        <li>
          Sąskaitas už jus draudimas apmokės tais atvejais, kai būsite nedirbę
          dėl ligos, nelaimingo atsitikimo ar prarasto darbo ilgiau nei 30
          dienų.
        </li>
        <li>
          Sumos, kurią už jūsų sąskaitas sumokės draudimas, jums nereikės
          grąžinti net ir tuomet, kai aplinkybės pasitaisys.
        </li>
        <li>
          Kad įsigaliotų draudimo apsauga jums tereikia pasirinkti „Viena
          sąskaita“ paslaugos planą „Maksimalus“ ir sumokėti plano mokestį. Kol
          galios paslaugos planas, tol galios ir jūsų pasirinkta draudimo
          apsauga.
        </li>
      </ul>
      <h5 className="my-4">Draudimo apsauga taikoma, jeigu:</h5>
      <ul className="my-4">
        <li>Jūsų nuolatinė gyvenamoji vieta yra Lietuvoje.</li>
        <li>Esate vyresnis nei 18 arba jaunesnis nei 65 metų amžiaus.</li>
        <li>
          Esate asmuo, dirbantis ne mažiau kaip 25 valandas per savaitę ir ne
          trumpiau kaip 6 mėnesius pagal neterminuotą darbo sutartį.
        </li>
      </ul>
      <h5 className="my-4">Draudimo išmokos dydžio paskaičiavimas:</h5>
      <table className="border-slate-400 border-collapse border p-2">
        <thead>
          <tr>
            <th className="border-slate-300 border p-1">
              Vidutinės paskutinių 3 mėnesių išlaidos per mėnesį
            </th>
            <th className="border-slate-300 border p-1">
              Maksimali mėnesinė išmoka*
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border-slate-300 border p-1">&lt; 100 €</td>
            <td className="border-slate-300 border p-1">100 €</td>
          </tr>
          <tr>
            <td className="border-slate-300 border p-1">100.01 € - 150 €</td>
            <td className="border-slate-300 border p-1">150 €</td>
          </tr>
          <tr>
            <td className="border-slate-300 border p-1">150.01 € - 200 €</td>
            <td className="border-slate-300 border p-1">200€</td>
          </tr>
          <tr>
            <td className="border-slate-300 border">&gt; 200 €</td>
            <td className="border-slate-300 border">250€</td>
          </tr>
        </tbody>
      </table>
      <p>
        *Draudimas padengia mokėjimus „Viena sąskaita“ platformoje, kurie yra ne
        didesni, nei ši paskaičiuota maksimali išmokos suma. Pavyzdžiui, jeigu
        sąskaitos suma bus mažesnė – draudimas tokio dydžio išlaidas ir padengs,
        jeigu paskyroje paruoštų sąskaitų bendra suma bus didesnė – draudimas
        padengs maksimalią sumą, kuri buvo paskaičiuota, tačiau ne visais
        atvejais tai padengs visą sumą, kurią teks sumokėti už mokesčius.
        Skirtumas tarp paruoštos sąskaitos ir išmokėtos klientui taip pat nėra
        nepervedamas.
      </p>
      <h5 className="my-4">Draudimo užsakymas ir galiojimas:</h5>
      <ul className="my-4">
        <li>
          Draudimą galite užsakyti, pasirinkdami „Viena sąskaita“ paslaugos
          planą „Maksimalus“ ir nurodydami pasirinktą draudimo apsaugą.
        </li>
        <li>
          Draudimas įsigalioja tada, kai apmokate „Viena sąskaita“ paslaugos
          planą „Maksimalus“ ir sulaukiate draudimo sertifikato. Draudimo
          sertifikato ir patvirtinimo apie draudimo įsigaliojimą gali tekti
          laukti dieną ar daugiau. Taip yra todėl, kad įmoka už paslaugos planą
          mes gauname tik kitą darbo dieną, ir tik patikrinę informaciją,
          paruošiame draudimo sertifikatą. Dėl draudimo sertifikato kreipkitės
          tuomet, jeigu jo nebūsite gavę ilgiau kaip dvi darbo dienos po atlikto
          mokėjimo.
        </li>
        <li>
          Įsigaliojus draudimui, apie tai atskirai jus informuosime SMS žinute
          ir atsiųsime patvirtinimą į paskyrą.
        </li>
        <li>
          Draudimo sertifikatą ir kitus dokumentus, pirmą kartą po paslaugos
          užsakymo, jums išsiųsime el. paštu, kuris bus nurodytas paslaugos
          užsakymo metu.
        </li>
        <li>
          Draudimo apsauga galios kol jūsų paskyroje bus aktyvus „Viena
          sąskaita“: paslaugos planas „Maksimalus“ ir kol reguliariai gausime
          įmokas už šį paslaugos planą.
        </li>
        <li>
          Jeigu bent vieną mėnesį neatliksite mokėjimo už „Viena sąskaita“
          paslaugos planą „Maksimalus“ iki mėnesio paskutinės dienos, draudimas
          bus atšauktas, o paslaugos planas bus pakeistas į kitą planą.
        </li>
        <li>
          Jeigu dėl pavėluotos įmokos bus atšauktas planas „Maksimalus“ ir
          nutrauktas draudimo galiojimas, 3 mėnesius neturėsite galimybės
          užsisakyti šios paslaugos iš naujo.
        </li>
        <li>
          Draudimo sertifikatą visada rasite Viena sąskaita paskyroje, o nutikus
          draudiminiam įvykiui visus dokumentus pateikti ir įvykį registruoti
          reikės el. paštu
          <a href="mailto::info@ergo.lt">info@ergo.lt</a> arba telefonais 1887,
          +370 5 2683222.
        </li>
      </ul>
      <h5 className="my-4">
        Draudimo dokumentai, su kuriais reikia susipažinti užsakant draudimo
        paslaugą:
      </h5>
      <BillInsuranceRulesFiles />
    </div>
  );
};
